/* ==========================================================================
   stools2 — predictive search (live results in the header search overlay)
   ========================================================================== */

(function () {
  const input = document.querySelector('[data-search-input]');
  const results = document.querySelector('[data-predictive-results]');
  if (!input || !results) return;

  const moneyFormat = results.getAttribute('data-money-format') || '{{amount}}';
  const searchUrl = results.getAttribute('data-search-url') || '/search';
  let controller;
  let timer;

  function money(amount) {
    if (amount == null || amount === '') return '';
    return moneyFormat.replace(/\{\{\s*[a-z_]+\s*\}\}/i, amount);
  }

  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  async function run(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=8' +
        '&resources[options][unavailable_products]=last';
      const res = await fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } });
      const data = await res.json();
      render(q, (data.resources && data.resources.results) || {});
    } catch (e) { /* aborted */ }
  }

  function render(q, r) {
    const products = r.products || [];
    const collections = r.collections || [];
    if (!products.length && !collections.length) {
      results.innerHTML = '<p class="predictive__empty">&ldquo;' + esc(q) + '&rdquo; için sonuç bulunamadı</p>';
      results.hidden = false;
      return;
    }
    let html = '<div class="predictive">';
    if (collections.length) {
      html += '<div class="predictive__chips">';
      collections.slice(0, 5).forEach(function (c) {
        html += '<a class="predictive__chip" href="' + c.url + '">' + esc(c.title) + '</a>';
      });
      html += '</div>';
    }
    if (products.length) {
      html += '<p class="predictive__heading">Ürünler</p>';
      html += '<div class="predictive__grid">';
      products.forEach(function (p) {
        const img = p.image
          ? '<span class="predictive__card-media"><img src="' + p.image + '" alt="" loading="lazy"></span>'
          : '<span class="predictive__card-media"></span>';
        const price = p.price ? '<span class="predictive__card-price">' + money(p.price) + '</span>' : '';
        html += '<a class="predictive__card" href="' + p.url + '">' + img +
          '<span class="predictive__card-title">' + esc(p.title) + '</span>' + price + '</a>';
      });
      html += '</div>';
    }
    html += '<a class="predictive__viewall" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '">Tüm sonuçları gör</a>';
    html += '</div>';
    results.innerHTML = html;
    results.hidden = false;
  }

  input.addEventListener('input', function () {
    const q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
    timer = setTimeout(function () { run(q); }, 220);
  });
})();
